(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('.jeieam-reviews slider-component').forEach((host) => {
      if (host.dataset.refined === 'true') return;

      const track = host.querySelector('[id^="Slider-"]');
      const items = track ? Array.from(track.querySelectorAll('[id^="Slide-"]')) : [];
      const range = host.querySelector('.jeieam-review-range');

      if (!track || !items.length) return;

      host.dataset.refined = 'true';
      track.style.removeProperty('height');

      let frame;

      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const left = track.scrollLeft;
          const right = left + track.clientWidth;
          const visible = items.filter(
            (item) => item.offsetLeft + item.offsetWidth > left + 2 && item.offsetLeft < right - 2
          );

          if (range && visible.length) {
            const first = items.indexOf(visible[0]) + 1;
            const last = items.indexOf(visible[visible.length - 1]) + 1;
            range.textContent = `${first === last ? first : `${first}–${last}`} / ${items.length}`;
          }
        });
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();